<div id="init-signup" class="k-center-box">
  <div class="k-center-box-content">
    <div class="init-signup-content">
      <h1 class="welcome-text">Welcome, introduce yourself.</h1>
      <input #nameInput placeholder="Name" maxlength="12"/>
      <hr>
      <button (click)="onContinueButtonClick(nameInput)">Continue</button>
    </div>
  </div>
</div>